import React, { useEffect } from 'react';
import {
  buildStandaloneSearchBox,
  loadPipelineActions,
  loadSearchHubActions
} from '@coveo/headless';
import { SearchBoxGlobal } from '../../components/search-box-global';
import { headlessSearchEngine } from '../../engine';
import { searchBox } from '../../controllers/controllers';

function CoveoListing(props) {
  const localization = JSON.parse(props.localization);
  const searchFields = JSON.parse(props.searchFields);
  const coveoConfig = JSON.parse(props.coveo);
  const searchBoxHeader = buildStandaloneSearchBox(headlessSearchEngine, {
    options: {
      redirectionUrl: props.resultsPage,
      highlightOptions: {
        notMatchDelimiters: {
          open: '<strong>',
          close: '</strong>'
        },
        correctionDelimiters: {
          open: '<i>',
          close: '</i>'
        }
      }
    }
  });

  // Setting up the custom properties for the search engine (Pipeline, SearchHub, fields, etc.)
  useEffect(() => {
    const { setPipeline } = loadPipelineActions(headlessSearchEngine);
    const { setSearchHub } = loadSearchHubActions(headlessSearchEngine);
    headlessSearchEngine.dispatch(setSearchHub(coveoConfig.QuerySearchHubName));
    headlessSearchEngine.dispatch(setPipeline(coveoConfig.QuerySearchHubName));
  });

  return (
    <div className="coveo-search-results--header coveo-header-search header-search__container">
      <SearchBoxGlobal
        controller={searchBoxHeader}
        labels={localization}
        resultsPage={props.resultsPage}
        modifier="--header"
        controllerSearch={searchBox}
      />
    </div>
  );
}

export default CoveoListing;
